import React from "react";
import { waitedLabel } from "./waiting.mjs";

/**
 * THE FOOTER ON A CARD THAT IS WAITING ON YOU — the verb, and how long it has
 * been waiting (Gabriel's mockup, 2026-09-07).
 *
 * The verb is the SERVER's verb (src/actions/model.js ACTIONS), lowercased,
 * never a phrasing of its own. The mockup drew this as "send follow-up"; the
 * word here is "follow up", because the same action is "Follow up now" on the
 * contact page and "follow up from call" on the chip immediately above, and a
 * third wording for one thing is how those three start to drift. Change the verb
 * in the model and all four surfaces change together.
 *
 * It is a real button, not a decorated div: the card itself is a draggable div
 * with an onClick, so before this the board had no keyboard route into a company
 * at all. It goes to the same place the card does — the POC's page, where the
 * action bar and its composer are — so the bar is the card's click with the next
 * step written on it.
 */
export default function WaitingBar({ action, onOpen }) {
  if (!action) return null;
  const waited = waitedLabel(action);
  return (
    <button
      type="button"
      className="crm-bcard__wait"
      // The chip above names the action; this says what to do about it. The
      // detail is the state of play ("met 1d ago, nothing sent since") and is
      // worth having on hover here too, since the chip's own title is the only
      // other place it appears on the board.
      title={action.detail || undefined}
      onClick={(e) => { e.stopPropagation(); onOpen(); }}
    >
      <span className="crm-bcard__wait-verb">
        <span aria-hidden="true">→ </span>
        {String(action.verb || "").toLowerCase()}
      </span>
      {waited && <span className="crm-bcard__wait-age crm-num">{waited}</span>}
    </button>
  );
}
